import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

type ButtonSize = 'small' | 'medium' | 'large';
type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'text';

interface ButtonProps {
  size?: ButtonSize;
  variant?: ButtonVariant;
  fullWidth?: boolean;
}

const Button = styled.button<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${({ size }) => 
    size === 'small' ? `${theme.spacing.xs} ${theme.spacing.sm}` :
    size === 'large' ? `${theme.spacing.md} ${theme.spacing.lg}` :
    `${theme.spacing.sm} ${theme.spacing.md}`
  };
  font-size: ${({ size }) => 
    size === 'small' ? theme.fontSizes.small :
    size === 'large' ? theme.fontSizes.large :
    theme.fontSizes.medium
  };
  font-weight: 600;
  width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
  border-radius: ${theme.radii.medium};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  
  ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return css`
          background-color: ${theme.colors.primary};
          color: white;
          &:hover {
            background-color: #3A80D2;
          }
        `;
      case 'secondary':
        return css`
          background-color: ${theme.colors.secondary};
          color: white;
          &:hover {
            background-color: #40D3B2;
          }
        `;
      case 'outline':
        return css`
          background-color: transparent;
          color: ${theme.colors.primary};
          border: 1px solid ${theme.colors.primary};
          &:hover {
            background-color: rgba(74, 144, 226, 0.1);
          }
        `;
      case 'text':
        return css`
          background-color: transparent;
          color: ${theme.colors.primary};
          padding: ${theme.spacing.xs} ${theme.spacing.sm};
          &:hover {
            background-color: rgba(74, 144, 226, 0.1);
          }
        `;
      default:
        return css`
          background-color: ${theme.colors.primary};
          color: white;
          &:hover {
            background-color: #3A80D2;
          }
        `;
    }
  }}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

Button.defaultProps = {
  size: 'medium',
  variant: 'primary',
  fullWidth: false,
};

export default Button; 